<template>
  <div class="users-profile">
    <div class="flex users-profile__header">
      <h2>Настройки профиля</h2>
      <el-button type="success" class="users-profile__header-btn">Сохранить</el-button>
    </div>
    <el-row :gutter="20" type="flex" class="flex-wrap">
      <el-col class="mb-16 flex d-column" :md="24" :lg="8">
        <el-card class="users-profile__card" shadow="always">
          <div class="card-avatar">
            <img src="/img/users/avatar.png" alt="user avatar" />
          </div>
          <div class="card-content">
            <p>Иван</p>
            <p>Иванов</p>
            <p>Иванович</p>
            <div class="card-activity">
              <span>Последняя активность:</span>
              <span>15 Июля 2020</span>
              <span>11:30</span>
            </div>
          </div>
        </el-card>
        <el-card class="flex-1">
          <div class="users-profile__settings">
            <p>Настройки</p>
            <el-form
              ref="ruleForm"
              :model="usersFormData"
              :rules="rules"
              label-position="top"
              class="demo-ruleForm"
            >
              <el-form-item label="Язык интерфейса">
                <el-select v-model="usersFormData.lang" class="w-full">
                  <el-option v-for="item in langOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Доступ к профилю">
                <el-select v-model="usersFormData.portfolio" class="w-full">
                  <el-option
                    v-for="item in portfolioOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Пароль">
                <el-input v-model="usersFormData.password" type="password" show-password>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small">Сменть пароль</el-button>
              </el-form-item>
              <el-form-item label="Настройка">
                <el-select v-model="usersFormData.settings" placeholder="Настройка" class="w-full">
                  <el-option
                    v-for="item in settingsOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" plain class="users-profile__settings-btn" size="small"
                  >Выйти из профиля</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
      <el-col class="mb-16 flex d-column" :md="24" :lg="16">
        <el-row type="flex" class="flex-wrap">
          <el-col>
            <div class="chart__remaining">
              <el-card class="mb-16">
                <div class="chart__remaining-wrapper">
                  <div class="chart__remaining-timer">
                    <svg-icon name="timer" class="timer-icon"></svg-icon>
                    <span>Время истекло, теперь каждые сутки отнимается 10 очков</span>
                  </div>
                  <div class="chart__remaining-progress">
                    <Progress type="exception" :percentage="20" />
                    <div class="progress-description">Потеря: <span>40 очков</span></div>
                  </div>
                  <div class="chart__remaining-progress">
                    <Progress type="exception" :percentage="20" />
                    <div class="progress-description">Время: <span>100 часов</span></div>
                  </div>
                  <el-button type="primary" plain class="chart__remaining-btn">
                    Перейти к дополнительным заданиям
                  </el-button>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-card class="flex-1">
          <div class="users-profile__chart">
            <p class="chart__title">Динамика обучения</p>
            <div class="chart__header">
              <div class="chart__table">
                <table>
                  <tr>
                    <td>Модуль</td>
                    <td class="flex">
                      <span>Вводно-фонетический</span>
                      <svg-icon name="arrow-down" class="chart__table-icon" />
                    </td>
                  </tr>
                  <tr>
                    <td>День</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>Группа</td>
                    <td>22</td>
                  </tr>
                </table>
              </div>
            </div>
            <Chart :chartOptions="chartOptions" :series="series" chartType="bar" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'UsersProfile',
  components: {
    Progress: () => import(/* WebpackChunkName: "Progress" */ '@/components/Common/Progress.vue'),
    Chart: () => import(/* WebpackChunkName: "Chart" */ '@/components/Common/Chart.vue')
  },
  data() {
    return {
      usersFormData: {
        lang: '',
        portfolio: '',
        password: ''
      },
      rules: {},
      settingsOptions: ['Настройки1', 'Настройки2'],
      portfolioOptions: ['Открыт', 'Закрыт'],
      langOptions: ['Русский', 'Английский'],
      chartData: [
        { date: 'День 1', visits: 200 },
        { date: 'День 2', visits: 400 },
        { date: 'День 3', visits: 179 },
        { date: 'День 4', visits: 300 },
        { date: 'День 5', visits: 0 },
        { date: 'День 6', visits: 0 },
        { date: 'День 7', visits: 0 },
        { date: 'День 8', visits: 0 }
      ]
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          id: 'wrapper',
          height: '100%'
        },
        legend: {
          show: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'top',
          horizontalAlign: 'left'
        },
        colors: ['#00A94F', '#0079C1'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '90%'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topRight'
          },
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const currentColor = w.config.colors[seriesIndex]

            const bar = document.querySelector('.apexcharts-tooltip')
            if (!bar || !currentColor) {
              return
            }
            bar.style.setProperty('--bar-color', currentColor)

            return `
            <div class="arrow_tooltip">
              <span>
                ${series[seriesIndex][dataPointIndex]}
              </span>
            </div>
           `
          }
        },
        responsive: [
          {
            breakpoint: 320,
            options: {
              plotOptions: {
                bar: {
                  horizontal: false
                }
              },
              legend: {
                position: 'top'
              }
            }
          }
        ],

        xaxis: {
          categories: this.chartData.map(item => item.date)
        }
      }
    },

    formatTaskData() {
      return {
        name: 'Основные задачи',
        data: this.chartData.map(item => item.visits)
      }
    },
    formatExtraData() {
      return {
        name: 'Дополнительные задачи',
        data: this.chartData.map(item => item.visits)
      }
    },
    series() {
      return [this.formatTaskData, this.formatExtraData]
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  &-avatar {
    img {
      margin-right: 16px;
      border-radius: 24px;
      width: 110px;

      @include sm-and-down {
        width: 94px;
      }
    }
  }

  &-content {
    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: -0.2px;
      color: $deepdark;

      &:nth-child(1) {
        padding-top: 10px;

        @include sm-and-down {
          padding-top: 4px;
        }
      }

      &:nth-child(3) {
        margin-bottom: 40px;
      }

      @include sm-and-down {
        font-size: 20px;
      }
    }
  }

  &-activity {
    span {
      display: block;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      letter-spacing: -0.08px;
      color: $deepdark;
      opacity: 0.5;

      &:first-child {
        white-space: nowrap;
      }

      @include sm-and-down {
        font-size: 13px;
      }
    }
  }
}

.users-profile {
  &__header {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;

    &-btn {
      @include md-and-down {
        display: none;
      }
    }

    h2 {
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      color: $luchmara;

      @include sm-and-down {
        margin-bottom: 24px;
        font-size: 20px;
      }
    }
  }

  &__card {
    margin-bottom: 20px;
  }

  &__settings {
    flex-direction: column !important;
    width: 70%;

    @include sm-and-down {
      width: 100%;
    }

    p {
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      color: #2f2f2f;
    }

    &-btn {
      margin-top: 40px;
    }
  }

  &__chart {
    width: 100%;

    @include sm-and-down {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }
}

.chart {
  &__title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: #2f2f2f;
  }

  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    width: 100%;

    @include extra-lgx-down {
      margin-bottom: 90px;
    }

    @include sm-and-down {
      margin-bottom: 10px;
    }
  }

  &__remaining {
    position: absolute;
    right: 20px;
    top: 20px;
    max-width: 400px;

    @include extra-lgx-down {
      max-width: 330px;
    }

    @include md-and-down {
      position: static;
      max-width: 100%;
    }

    &-progress {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .progress-description {
        display: inline-flex;
        /*width: 172px;*/
        flex-basis: 172px;
        margin-left: 5px;
        white-space: nowrap;
        font-size: 13px;
        letter-spacing: -0.08px;
        color: #b6b9c3;

        span {
          padding-left: 4px;
          font-size: 13px;
          letter-spacing: -0.08px;
          color: $deepdark;
          white-space: nowrap;
        }
      }
    }

    &-btn {
      margin-top: 20px;
      width: 100%;
    }

    &-wrapper {
      @include sm-and-down {
        width: 100%;
      }
    }

    &-timer {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
      font-size: 15px;
    }
  }

  &__table {
    &-icon {
      margin-left: 10px;
      width: 10px;
      fill: $french-gray;

      @include sm-and-down {
        display: none;
      }
    }

    td {
      padding-bottom: 10px;

      &:nth-child(1) {
        padding: 0 14% 10px 0;
        font-size: 15px;
        color: $french-gray;

        @include sm-and-down {
          padding-right: 12%;
        }
      }

      &:nth-child(2) {
        font-size: 15px;
        color: #3e4347;

        @include sm-and-down {
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
  }
}

.timer-icon {
  margin-right: 10px;
  width: 30px;
  fill: #ee2a24;
  vertical-align: middle;

  @include sm-and-down {
    width: 60px;
  }
}

.mark {
  font-size: 13px;
  letter-spacing: -0.08px;
  color: $deepdark;
  white-space: nowrap;
}

::v-deep .el-form-item__label {
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  color: #b6b9c3;
}

::v-deep .apexcharts-inner > defs:first-of-type > clipPath:first-of-type {
  clip-path: inset(0% 0% 0% 0% round 10px 10px 0 0);
}

::v-deep #chart .apexcharts-tooltip {
  --bar-color: #f2994a;
  padding: 4px 16px;
  border-radius: 10px;
  color: $white;
  box-shadow: 0 0 11px rgba(0, 0, 0, 0.12);
  transform: translateX(-50%) translateY(-100%);
  overflow: visible !important;

  span {
    position: relative;
    font-weight: bold;
    font-size: 24px;
    color: var(--bar-color, #f2994a);
  }

  &:before {
    right: 34%;
    top: 68%;
    border: 10px solid transparent;
    border-top: 10px solid #fff;
    content: ' ';
    height: 24px;
    width: 10px;
    position: absolute;
    pointer-events: none;
    transform: translateY(50%);
    filter: drop-shadow(0 4px 3px #b6b9c3ab);
  }
}
</style>
